import { useMemo, useState } from 'react';
import { useTranslation } from '../../../../lib/i18n';
import { blogDraftReviewHtml, blogDraftTitle, blogSitePreviewAddress, type BlogDraftPreviewCardData } from '../../../../lib/blog-draft-preview';
import { prefetchBlogDraftReview, useBlogDraftInlinePreview } from '../../../../lib/blog-draft-preview-api';
import { inlinePreviewDocument } from '../../../../lib/email-review';
import { useIsPhone } from '../../../../lib/use-is-phone';
import { InlineHtmlPreview } from './InlineHtmlPreview';

const PHONE_WIDTH = 375;
const DESKTOP_WIDTH = 980;

export function BlogDraftInlinePreview({ workspaceId, card, cardKey }: { workspaceId: string; card: BlogDraftPreviewCardData; cardKey: string }) {
  const { t } = useTranslation();
  const [seen, setSeen] = useState(false);
  const ids = { workspaceId, metaSiteId: card.metaSiteId, draftPostId: card.draftPostId };
  const preview = useBlogDraftInlinePreview(ids, cardKey, seen);
  const phone = useIsPhone();
  const title = preview.data ? blogDraftTitle(preview.data, card.title) : card.title;
  const site = useMemo(
    () => (preview.data ? blogSitePreviewAddress(preview.data.sitePreviewUrl ?? '', phone ? 'phone' : 'desktop', window.location.origin) : null),
    [preview.data, phone],
  );
  const html = useMemo(
    () => (preview.data && !site ? inlinePreviewDocument(blogDraftReviewHtml(preview.data, title)) : undefined),
    [preview.data, site, title],
  );
  return (
    <InlineHtmlPreview
      src={site ?? undefined}
      html={html}
      title={title || t('blogDraft.card.title')}
      naturalWidth={site && !phone ? DESKTOP_WIDTH : PHONE_WIDTH}
      status={t(preview.isError ? 'blogDraft.unavailable' : 'blogDraft.loading')}
      failed={preview.isError}
      onSeen={() => {
        if (seen && preview.isStale) void preview.refetch();
        setSeen(true);
        prefetchBlogDraftReview(ids, phone ? 'mobile' : 'desktop', cardKey);
      }}
      testId="blogDraftInlinePreview"
    />
  );
}
